import type { StatusVariant } from "../../components/StatusLine";
import type { AuthoringStatus } from "../../lib/types";

export { fileToText, formatTime, pluralize } from "../../lib/format";

export const DEFAULT_MAX_ITERATIONS = 3;

export const STATUS_LABELS: Record<AuthoringStatus, string> = {
  queued: "Queued",
  enriching: "Enriching sample",
  iterating: "Iterating",
  converged: "Converged",
  max_iter_reached: "Max iterations reached",
  validated: "Validated",
  failed: "Failed",
  promoted: "Promoted",
};

export function statusVariant(status: AuthoringStatus): StatusVariant {
  if (status === "converged" || status === "promoted" || status === "validated")
    return "success";
  if (status === "failed") return "error";
  if (status === "max_iter_reached") return "error";
  if (status === "queued" || status === "enriching" || status === "iterating")
    return "running";
  return "idle";
}

